export const legalConfig = {
  company: {
    name: "LIBPASS",
    legalForm: "SAS",
    siret: "928 508 811 00017",
    address: "4 rue Deodat De Severac, 66000 Perpignan, France",
    capital: "1 200,00 €",
    rcs: "928 508 811 R.C.S. Perpignan",
    tva: "FR46928508811",
    phone: "+33 07 83 40 65 42",
    email: "contact@libpass.fr",
    directorOfPublication: "Jaoid FARCHICH",
  },
  dpo: {
    name: null, // Non obligatoire au regard de l'art. 37 RGPD (nature et taille des activités)
    email: "privacy@koken.libpass.fr",
    address: "4 rue Deodat De Severac, 66000 Perpignan, France",
  },
  support: {
    email: "support@kokenapp.com",
  },
  security: {
    email: "security@koken.libpass.fr",
    disclosurePolicyUrl: "https://kokenapp.com/securite/divulgation-responsable",
    securityTxtUrl: "https://kokenapp.com/.well-known/security.txt",
    responseSlaBusinessDays: 5,
  },
  app: {
    url: "https://kokenapp.com",
  },
  hosting: {
    // Hébergeur applicatif : l'application web (front) est servie par la
    // plateforme Lovable (vérifié DNS 2026-07-24 : A kokenapp.com → IP Lovable).
    web: {
      provider: "Lovable Labs Incorporated",
      address:
        "1111b South Governors Avenue, Dover, DE 19904, États-Unis. Représentant UE : Lovable Labs AB, Regeringsgatan 25, 111 53 Stockholm, Suède",
      region: "Diffusion mondiale du front web ; données applicatives hébergées en UE (voir ci-dessous)",
      website: "https://lovable.dev",
      role: "Hébergement et diffusion de l'application web (front)",
    },
    // Registrar, DNS ET acheminement du trafic web de kokenapp.com. Le proxy
    // est actif : verifie le 07/08/2026 (en-tetes de reponse), et corrige ici
    // apres qu'une ancienne note « pas de proxy/CDN » eut essaime dans le
    // dossier client et dans la politique publique.
    dns: {
      provider: "Cloudflare, Inc.",
      address: "101 Townsend Street, San Francisco, CA 94107, États-Unis",
      region: "Point de présence de Marseille pour les visiteurs français ; société certifiée Data Privacy Framework UE-US",
      website: "https://www.cloudflare.com",
      role: "Enregistrement du domaine, résolution DNS et acheminement du trafic web (chiffrement de la liaison, protection contre la saturation, filtrage des robots)",
    },
    // Hebergement des donnees utilisateurs. ATTENTION a la chaine : notre
    // sous-traitant est LOVABLE, via son offre Lovable Cloud. Supabase est le
    // sous-traitant ULTERIEUR de Lovable, dont ce dernier detient le compte et
    // l'accord. Nous n'avons pas de relation contractuelle directe avec
    // Supabase, et nous ne pouvons donc pas invoquer son accord comme le
    // notre. Meme logique pour l'IA : nous passons par la passerelle Lovable,
    // qui appelle Google. Ne jamais presenter Supabase ou Google comme nos
    // sous-traitants directs.
    data: {
      provider: "Lovable Labs Incorporated (offre Lovable Cloud)",
      address: "1111b South Governors Avenue, Dover, DE 19904, États-Unis. Représentant UE : Lovable Labs AB, Regeringsgatan 25, 111 53 Stockholm, Suède",
      region: "Base de données opérée par Supabase, sous-traitant ultérieur de Lovable, région AWS eu-west-1 (Dublin, Irlande)",
      website: "https://lovable.dev",
      role: "Hébergement des données (base PostgreSQL, stockage de fichiers, authentification) via Lovable Cloud",
    },
  },
  /**
   * Médiateur de la consommation (art. L.612-1 Code de la conso).
   * Conservé pour réactivation quand la boutique ASC / SLD reprend
   * (cf. `SLD_PAUSED` dans `src/lib/sldPause.ts`).
   * Ne PAS afficher en UI publique tant que `SLD_PAUSED === true`
   * (pas d'offre B2C effective → obligation L.612-1 non déclenchée).
   */
  mediation: {
    provider: "CM2C - Centre de Médiation de la Consommation de Conciliateurs de Justice",
    address: "14 rue Saint-Jean, 75017 Paris",
    website: "https://www.cm2c.net",
  },
  consentDuration: {
    cookies: 13,           // CNIL recommandation
    cguPrivacy: null,      // Acceptation versionnée, sans expiration générique
    proofRetention: 25,    // Conservation probatoire interne
  },
  lastUpdate: {
    mentionsLegales: "2026-07-24",
    // 2026-09-14 : ajout article 8bis (analyse d'aliments par photo).
    cgu: "2026-09-14",
    cgv: "2026-04-06",
    // 2026-07-24 : mise à jour corrective (hébergement réel eu-west-1,
    // sous-traitants US + garanties art. 46, mesure d'audience hébergeur).
    // Une nouvelle validation n'est demandée qu'en cas d'évolution qui la
    // justifie. L'acceptation n'expire pas automatiquement tous les 13 mois.
    // 2026-09-14 : ajout section 2bis (analyse d'aliments par photo).
    // 2026-09-21 : section 7, serveurs publics Overpass API (sentiers) interrogés depuis l'appareil.
    privacyPolicy: "2026-09-21",
    // 2026-07-27 : ajout section application mobile et services techniques tiers.
    // 2026-09-21 : section 3.2, serveurs publics Overpass API (sentiers).
    cookies: "2026-09-21",
    securityData: "2026-02-27",
    responsibleDisclosure: "2026-05-21",
  },
  dataRetention: {
    userData: "90 jours après la fin du contrat",
    activityLogs: "3 ans (politique de sécurité interne ; données de connexion : 1 an minimum, LCEN)",
    cookies: "13 mois maximum",
    analyticsData: "26 mois",
    consentProof: "25 mois à compter de l'enregistrement de la preuve, sous réserve des obligations légales applicables",
  },
};
